/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface InvoiceChallengeMergeField
 */
export interface InvoiceChallengeMergeField {
  /**
   *
   * @type {string}
   * @memberof InvoiceChallengeMergeField
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof InvoiceChallengeMergeField
   */
  description: string;
}

/**
 * Check if a given object implements the InvoiceChallengeMergeField interface.
 */
export function instanceOfInvoiceChallengeMergeField(
  value: object,
): value is InvoiceChallengeMergeField {
  if (!("key" in value) || value["key"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined)
    return false;
  return true;
}

export function InvoiceChallengeMergeFieldFromJSON(
  json: any,
): InvoiceChallengeMergeField {
  return InvoiceChallengeMergeFieldFromJSONTyped(json, false);
}

export function InvoiceChallengeMergeFieldFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceChallengeMergeField {
  if (json == null) {
    return json;
  }
  return {
    key: json["key"],
    description: json["description"],
  };
}

export function InvoiceChallengeMergeFieldToJSON(
  json: any,
): InvoiceChallengeMergeField {
  return InvoiceChallengeMergeFieldToJSONTyped(json, false);
}

export function InvoiceChallengeMergeFieldToJSONTyped(
  value?: InvoiceChallengeMergeField | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    key: value["key"],
    description: value["description"],
  };
}
